import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { WINDOW_RESIZE } from 'Application/Store/Actions/LayoutTypes'

const PORTRAIT_MAX_WIDTH = 932

const computeLayout = () => {
  const w = window.innerWidth
  const h = window.innerHeight
  const isPortrait = w <= PORTRAIT_MAX_WIDTH && h > w
  return {
    width: w,
    height: h,
    isPortrait,
    isMobileLandscape: !isPortrait && w <= PORTRAIT_MAX_WIDTH,
  }
}

export const useResize = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const handleResize = () => {
      dispatch({ type: WINDOW_RESIZE, payload: computeLayout() })
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    window.addEventListener('orientationchange', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('orientationchange', handleResize)
    }
  }, [dispatch])
}
